<template lang="pug">
  li.empty-collection
    img.collection-img(:src="src" :alt="label")
    a.button--link(:href="href", :disabled="disabled")
      icon(v-if="icon", :name="icon", :size="iconSize")
      span {{ label }}
</template>

<script>
  import Icon from '../basic/Icon.vue'
  import PrimaryButton from './PrimaryButton.vue'

  export default {
    extends: PrimaryButton,
    components: { Icon }, 
    name: 'LinkButtonImage',
    props: {
      src: {
        type: String,
        default: '#'
      },
      href: {
        type: String,
        default: '#'
      }
    }
  }
</script>

<style scoped lang="scss">
</style>